import { render } from "./VerticalSidebar.vue?vue&type=template&id=00c141cb&scoped=true"
import script from "./VerticalSidebar.vue?vue&type=script&lang=js"
export * from "./VerticalSidebar.vue?vue&type=script&lang=js"

import "./VerticalSidebar.vue?vue&type=style&index=0&id=00c141cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c141cb"]])

export default __exports__